export default __webpack_public_path__ + "static/hero_placeholder-681dac0c0f4046fd29ccd2be1392ad55.png";